// T Santosh Kumar 24/03/2023 3225736869 Added the Icon
// Akhila 04/19/2023 3225736869  table reusable in account summary
// Akhila 06/05/2023 3225736869 bug fix preppropulation issue in account summary

import React, {useEffect, useState} from 'react';
import {Button, Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import {defaultRows, tablePageRows} from '../../../constants/ReusableTablePagination';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {useDispatch, useSelector} from 'react-redux';
import DialogBox from '../../../components/DialogBox';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {
  getNotesDetails,
  postNotesData,
  fetchNotesData,
  resetClientInfo,
} from '../../../redux/reducers/clientMangement/Organizaation';
import AddUserDefinedNotes from '../../../components/AddUserDefinedNotes';
import moment from 'moment';

import AddIcon from '@material-ui/icons/AddOutlined';

export default function searchTable({
  orgType,
  id,
  AccountSummary,
  clientInfoData,
  clientNumber,
  organizationAccess,
}) {
  const {isLoading, errorMsg, successMsg, notesData, notesTableData} =
    useSelector(({organization}) => organization);

  const transcription = '';
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const dispatch = useDispatch();
  const [rows, setRows] = useState(defaultRows);
  const [open, setOpen] = useState(false);

  const getApiData =
    notesTableData && notesTableData.length > 0 ?
      notesTableData.map((item, i) => ({
        ...item,
      })) :
      [];
  useEffect(() => {
    if (successMsg) {
      dispatch(getNotesDetails(id, orgType));
      handleClose();
    }
  }, [successMsg]);

  const columns = [
    {
      title: 'Note Date and Time',
      field: 'noteDttm',
      render: (rowData) => (
        <>
          {rowData?.noteDttm && moment(rowData.noteDttm).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Note Type',
      field: 'noteType',
    },
    {
      title: 'Note Text',
      field: 'noteText',
      className: 'organizationNotes',
      render: (rowData) => (
        <>
          <div
            style={{
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.noteText}
          </div>
        </>
      ),
    },
    {
      title: 'Created By',
      field: 'createdBy',
      render: (rowData) => (rowData?.createdBy ? rowData.createdBy : '-'),
    },
  ];

  useEffect(() => {
    if (successMsg) {
      dispatch(resetClientInfo());
    }
  }, [successMsg]);
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (AccountSummary && clientNumber) {
      dispatch(fetchNotesData(clientNumber));
    }
  }, [AccountSummary, clientNumber]);
  const dispatchSystemNotes = (data) => {
    if (data) {
      dispatch(
        postNotesData({
          orgId: id,
          orgNotesId: 0,
          orgType: orgType || '',
          noteText: data,
        }),
      );
    }
  };

  return (
    <div className="mt-3">
      <DialogBox
        open={open}
        dialogClose={handleClose}
        hideFooter={true}
        maxWidth={'lg'}
        title={`Add Notes`}
      >
        <AddUserDefinedNotes
          dispatchRecordFormatSystemNotes={dispatchSystemNotes}
          transcription={transcription}
          charLimitMsg={charLimitMsg}
          isLoading={isLoading}
          setCharLimitMsg={setCharLimitMsg}
        />
      </DialogBox>
      <Grid item xs={12} className="">
        <div
          className={`mb-4 global-field-table custom-table drag-and-drop-table custom-map-sec  new-standard-textfields`}
        >
          <GuiTable
            title={`Notes`}
            columns={columns}
            icons={tableIcons}
            data={
              notesData?.length > 0 ?
                notesData?.map((item) => ({...item})) :
                getApiData ?
                  getApiData :
                  []
            }
            options={{
              search: false,
              pageSize: rows,
              toolbarButtonAlignment: 'right',
              showTextRowsSelected: false,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={
              !AccountSummary && [
                {
                  icon: () => (
                    <>
                      <Button
                        type="button"
                        variant="outlined"
                        className={`search-btn`}
                        startIcon={<AddIcon />}
                        disabled={!organizationAccess?.edit}
                      >
                        Add Notes
                      </Button>
                    </>
                  ),
                  disabled: !organizationAccess?.edit,
                  isFreeAction: true,
                  onClick: (event) => {
                    setOpen(true);
                  },
                },
                // {
                //   icon: () => <EditOutlinedIcon />,
                //   tooltip: "Edit",
                //   onClick: (event, rowData) => {},
                // },
              ]
            }
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
          />
        </div>
      </Grid>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
}
